var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SectionContainerPage",
    [
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c(
            "v-flex",
            [
              _c("SectionActivityDetail", {
                attrs: {
                  breadCrumbs: _vm.breadCrumbs,
                  title: _vm._entityPropertyValueByName({
                    entityList: _vm.activityTypeList,
                    idKey: "id",
                    idValue: _vm.activityDetail.typeId,
                    propertyKey: "name",
                  }),
                  toolbarActions: [
                    {
                      text: "Edit Activity",
                      icon: "edit",
                      iconColor: "warning",
                      emitEvent: "onEditActivityClicked",
                    },
                  ],
                  activityDetail: _vm.activityDetail,
                  modelList: _vm.modelList,
                  manufacturerList: _vm.manufacturerList,
                  categoryList: _vm.categoryList,
                  activityTypeList: _vm.activityTypeList,
                  assetStatusList: _vm.assetStatusList,
                  locationList: _vm.locationList,
                  clientList: _vm.clientList,
                  userList: _vm.userList,
                  isLoading: _vm.isLoading,
                },
                on: {
                  onClickBreadcrumb: (val) =>
                    _vm.$emit("onClickBreadcrumb", val),
                  onEditActivityClicked: _vm.showConfirmWantEditActivity,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              _c(
                "v-tabs",
                {
                  attrs: { dark: "" },
                  model: {
                    value: _vm.currentTab,
                    callback: function ($$v) {
                      _vm.currentTab = $$v
                    },
                    expression: "currentTab",
                  },
                },
                [
                  _c(
                    "v-tab",
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("construction"),
                      ]),
                      _vm._v(
                        _vm._s(
                          `Equipment (${
                            (_vm.activityDetail.assetList &&
                              _vm.activityDetail.assetList.length) ||
                            0
                          })`
                        ) + "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tab",
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("attachment"),
                      ]),
                      _vm._v(
                        _vm._s(
                          `Attachments (${
                            (_vm.activityDetail.attachmentList &&
                              _vm.activityDetail.attachmentList.length) ||
                            0
                          })`
                        ) + "\n        "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.currentTab === _vm.tabAssets
            ? _c(
                "v-flex",
                [
                  _c("SectionAssetList", {
                    attrs: {
                      xs12: "",
                      isPrimary: false,
                      title: "Activity Equipment",
                      shouldShowCheckBoxes: false,
                      assetList: _vm.activityDetail.assetList || [],
                      modelList: _vm.modelList,
                      manufacturerList: _vm.manufacturerList,
                      categoryList: _vm.categoryList,
                      activityTypeList: _vm.activityTypeList,
                      assetStatusList: _vm.assetStatusList,
                      locationList: _vm.locationList,
                      clientList: _vm.clientList,
                      userList: _vm.userList,
                      isLoading: _vm.isLoading,
                    },
                    on: {
                      onClickViewEquipment: (val) =>
                        _vm.$emit("onClickViewEquipmentFromActivityDetail", {
                          ...val,
                          breadCrumbTitle: _vm._entityPropertyValueByName({
                            entityList: _vm.activityTypeList,
                            idKey: "id",
                            idValue: _vm.activityDetail.typeId,
                            propertyKey: "name",
                          }),
                        }),
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentTab === _vm.tabAttachments
            ? _c(
                "v-flex",
                [
                  _c("SectionAttachmentList", {
                    attrs: {
                      xs12: "",
                      isPrimary: false,
                      title: "Activity Attachments",
                      attachmentList: _vm.activityDetail.attachmentList || [],
                      activityTypeList: _vm.activityTypeList,
                      userList: _vm.userList,
                      locationList: _vm.locationList,
                      modelList: _vm.modelList,
                      isLoading: _vm.isLoading,
                      showUnlinkButton: true,
                    },
                    on: {
                      onClickUnlinkAttachment: (val) =>
                        _vm.onConfirmUnlinkAttachment(val),
                      onClickViewAttachment: (val) =>
                        _vm.onClickViewAttachment(val),
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("DialogFormActivityEdit", {
        attrs: {
          showDialog: _vm.showDialogFormActivityEdit,
          activityDetail: _vm.activityDetail,
          activityTypeList: _vm.activityTypeList,
          assetStatusList: _vm.assetStatusList,
          clientList: _vm.clientList,
          userList: _vm.userList,
          locationList: _vm.locationList,
          modelList: _vm.modelList,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormActivityEdit = false
          },
          onSubmitClicked: (val) => [_vm.onDialogFormActivityEditSubmit(val)],
        },
      }),
      _vm._v(" "),
      _c("DialogFormConfirmation", {
        attrs: {
          showDialog: _vm.confirmationDialogShow,
          title: _vm.confirmationDialogTitle,
          message: _vm.confirmationDialogMessage,
          submitButtonText: _vm.confirmationDialogSubmitButtonText,
          submitButtonIcon: _vm.confirmationDialogSubmitButtonIcon,
          submitButtonColor: _vm.confirmationDialogSubmitButtonColor,
          cancelButtonText: _vm.confirmationDialogCancelButtonText,
          showCancelButton: _vm.confirmationDialogShowCancelButton,
          isLoading: _vm.isLoading,
        },
        on: {
          onSubmitClicked: _vm.onConfirmationDialogSubmitClicked,
          onCancelClicked: _vm.onConfirmationDialogCancelClicked,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }